var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.sendBranchWindow.visible
        ? [
            _vm.sendBranchSelectObject === 2
              ? _c(
                  "el-dialog",
                  {
                    directives: [
                      { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                    ],
                    attrs: {
                      visible: _vm.sendBranchWindow.visible,
                      title: _vm.$t("SeaExport.ConsignationSI"),
                      width: "550px",
                      "close-on-click-modal": false
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.sendBranchWindow, "visible", $event)
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "40px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#000000",
                                "font-size": "14px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.EntrustedRecipient"))
                              )
                            ]
                          )
                        ]),
                        _vm._l(_vm.sendBranchWindow.items, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-form-item",
                            {
                              key: index,
                              attrs: {
                                label:
                                  item.selectObject === 0
                                    ? _vm.$t("SeaExport.CustomerService")
                                    : _vm.$t("SeaExport.Operation")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  "method-params": {
                                    officeId:
                                      _vm.sendBranchWindow.office.officeId,
                                    category: "role",
                                    shape:
                                      item.selectObject === 0 ? "csr" : "op"
                                  }
                                },
                                on: {
                                  change: function(p) {
                                    item.userId = p.value
                                    _vm.userIdAI_changeHandler(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "40px",
                          inline: true,
                          "label-position": "left"
                        }
                      },
                      [
                        _c("el-form-item", { attrs: { label: " " } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "200px",
                                color: "#000000",
                                "font-size": "14px",
                                "text-align": "center"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters.currentOffice.chineseName
                                )
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", { attrs: { label: " " } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "200px",
                                color: "#000000",
                                "font-size": "14px",
                                "text-align": "center"
                              }
                            },
                            [_vm._v(_vm._s(_vm.sendBranchWindow.title))]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: " " } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { value: "consignee", disabled: "" }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Message.Consignee"),
                                    value: "consignee"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "44px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { color: "rgb(153, 153, 153)" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v("———")]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                on: { change: _vm.onConsigneeTargetChange },
                                model: {
                                  value: _vm.sendBranchWindow.consigneeTarget,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sendBranchWindow,
                                      "consigneeTarget",
                                      $$v
                                    )
                                  },
                                  expression: "sendBranchWindow.consigneeTarget"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Message.Consignee"),
                                    value: "consignee"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ConsignationCompany"
                                    ),
                                    value: "customer"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: " " } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  value: "consigneeDetail",
                                  disabled: ""
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ConsigneeDetail"),
                                    value: "consigneeDetail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "44px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { color: "rgb(153, 153, 153)" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v("———")]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                on: {
                                  change: _vm.onConsigneeDetailTargetChange
                                },
                                model: {
                                  value:
                                    _vm.sendBranchWindow.consigneeDetailTarget,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sendBranchWindow,
                                      "consigneeDetailTarget",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "sendBranchWindow.consigneeDetailTarget"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ConsigneeDetail"),
                                    value: "consigneeDetail"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ShipperDetail"),
                                    value: "shipperDetail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { "margin-top": "20px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("queryJob.NoteConsigneeCustomerExportImport")
                        )
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        },
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { color: "#000000" },
                            on: { change: _vm.onCheckConsigneeDefaultChange },
                            model: {
                              value: _vm.sendBranchWindow.checkConsigneeDefault,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.sendBranchWindow,
                                  "checkConsigneeDefault",
                                  $$v
                                )
                              },
                              expression:
                                "sendBranchWindow.checkConsigneeDefault"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("queryJob.SetAsDefaultExportInfo"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.enterSendHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                            ),
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.sendBranchWindow.visible = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "el-dialog",
                  {
                    directives: [
                      { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                    ],
                    attrs: {
                      visible: _vm.sendBranchWindow.visible,
                      title: _vm.sendBranchWindow.title,
                      width: "360px",
                      "close-on-click-modal": false
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.sendBranchWindow, "visible", $event)
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "85px",
                          "label-position": "left"
                        }
                      },
                      [
                        _vm._l(_vm.sendBranchWindow.items, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-form-item",
                            {
                              key: index,
                              attrs: {
                                label:
                                  item.selectObject === 0
                                    ? _vm.$t("SeaExport.CustomerService")
                                    : _vm.$t("SeaExport.Operation")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                attrs: {
                                  "method-params": {
                                    officeId:
                                      _vm.sendBranchWindow.office.officeId,
                                    category: "role",
                                    shape:
                                      item.selectObject === 0 ? "csr" : "op"
                                  }
                                },
                                on: {
                                  change: function(p) {
                                    item.userId = p.value
                                    _vm.userIdAI_changeHandler(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: { margin: "0 auto", width: "fit-content" },
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.enterSendHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                        ),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.sendBranchWindow.visible = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.checkingDialog.visible,
            title: _vm.$t("SystemMaintenance.ExportToImport"),
            width: "820px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkingDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "check-tip" }, [
            _c("img", {
              staticStyle: { "margin-bottom": "15px" },
              attrs: { src: _vm.trueIcon }
            }),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("queryJob.BatchProgressPleaseReferBelow")))
            ])
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.checkingDialog.rowData, height: 310 } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "serialNumber",
                  label: _vm.$t("CargoMsg.Cargo_SerialNo"),
                  width: "200",
                  align: "center",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "jobNo",
                  label: _vm.$t("Message.OddNumbers"),
                  width: "300",
                  align: "center",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "state",
                  label: _vm.$t("CargoMsg.Cargo_Status"),
                  width: "295",
                  align: "center",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.state === "checking"
                          ? _c("div", [
                              _c("img", { attrs: { src: _vm.loadingIcon } })
                            ])
                          : row.state === "success"
                          ? _c("div", [
                              _c("img", { attrs: { src: _vm.acceptIcon } })
                            ])
                          : _c("div", [
                              _c("img", { attrs: { src: _vm.rejectIcon } })
                            ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.checkingDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }